import { inject, Injectable } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { AbstractApplicantProfileService } from '../../../services/abstract-applicant-profile.service';
import { BoomerHttpClient } from '../../../../../shared/services/boomer-http-client';

@Injectable()
export class PlanDetailsFacade {
  private readonly applicantProfileService = inject(AbstractApplicantProfileService);
  private readonly http = inject(BoomerHttpClient);

  getPlanDetails(planID: string, planType: number) {
    return this.applicantProfileService
      .getApplicantId()
      .pipe(
        switchMap(id =>
          this.http.get(`/insurance-application/recommended-plans/${id}/plan/${planID}?planType=${planType}`),
        ),
      );
  }
}

export interface PlanCostSummary {
  dataSource: {
    tierNumber: string | null;
    tierDescription: string;
    preferredRetailPharmacy30: { value: string; type: CostType };
    standardRetailPharmacy30: { value: string; type: CostType };
    preferredMailOrderPharmacy90: { value: string; type: CostType };
    standardMailOrderPharmacy90: { value: string; type: CostType };
  }[];
}

export enum CostType {
  ONE = 1,
  TWO = 2,
}
